exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".benutzer-edit-view .captcha-error{color:#ff2b59}.benutzer-edit-view form:not(.ng-submitted) .captcha-error{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/benutzerverwaltung/component/benutzerEditView/benutzerEditView.scss
// module id = hwXT
// module chunks = 0